import { getDistanceKm, getUserLocation } from "../../utils/geo";
import { showModal, pushScreens } from "../modal";
import { loadingAction, ajaxPendingAction, ajaxSuccessAction } from "../ajax";
import { setUserLocationAction } from "../auth";
import { intlCityAction } from "../intl";
import { getModelsAction } from "./actions";
import { getCity } from "../../selectors";

const serverState = window.initialState;
const serverCityId = serverState.intl.cityId;

export default function searchAction() {
  return async (dispatch, getState) => {
    const startTime = new Date().getTime();
    const state = getState();

    dispatch(ajaxPendingAction());

    // Get city to search in
    let city;

    if (serverCityId) {
      city = getCity(state);
    } else {
      // Ask for user location permission
      dispatch(
        loadingAction({
          title: "Searching for escorts near you...",
          message:
            "Please share your location to access live escort results near you. Please note your location is not stored.",
        })
      );

      // Get user location
      let lat;
      let lng;

      const pos = await getUserLocation();

      if (pos) {
        lat = pos.coords.latitude;
        lng = pos.coords.longitude;

        dispatch(setUserLocationAction({ lat, lng }));
      }

      // Try to find the closest city to user location
      if (lat & lng) {
        const { intl } = state;

        city = intl.cities.find(
          (city) => getDistanceKm(city.lat, city.lng, lat, lng) <= 50
        );
      }
    }

    // Search models
    if (city) {
      dispatch(loadingAction({ title: `Locating escorts in ${city.name}...` }));

      if (!serverCityId) {
        dispatch(
          intlCityAction({ cityId: city.id, countryId: city.country_id })
        );
      }

      await dispatch(getModelsAction());
      dispatch(
        pushScreens([
          "region",
          "city",
          "gender",
          "outcall",
          "time",
          "duration",
          "models",
        ])
      );
    }

    // Open app
    const endTime = new Date().getTime();
    const wait = Math.max(2500 - (endTime - startTime), 0);

    setTimeout(() => {
      dispatch(ajaxSuccessAction());
      dispatch(loadingAction(null));
      dispatch(showModal());
    }, wait);
  };
}
